
import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FeedbackPopup } from "@/components/FeedbackPopup";
import { useFeedbackPopup } from "@/hooks/useFeedbackPopup";
import { supabase } from "@/integrations/supabase/client";

export const FeedbackButton: React.FC = () => {
  const [user, setUser] = React.useState<any>(null);

  // Get current user for feedback submission logic
  React.useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    fetchUser();
  }, []);

  const {
    showFeedbackPopup,
    setShowFeedbackPopup,
    submitFeedback,
  } = useFeedbackPopup(user);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="flex items-center gap-1 border-[#CCCCCC] hover:bg-[#E8F0F8]"
        onClick={() => setShowFeedbackPopup(true)}
        type="button"
      >
        <MessageCircle className="h-4 w-4 mr-1" />
        Feedback
      </Button>
      <FeedbackPopup
        open={showFeedbackPopup}
        onOpenChange={setShowFeedbackPopup}
        onSubmit={submitFeedback}
      />
    </>
  );
};
